
import { Component } from 'vue-property-decorator'
import InputSingleLine from '@/components/Rain/Inputs/InputSingleLine.vue'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

@Component<SearchBar>({
    components: {
        FontAwesomeIcon,
    },
})
export default class SearchBar extends InputSingleLine {
    private faSearch = faSearch
}
